import styled from "@emotion/styled";
import { breakpoints } from "../../../constants";
import { FilterGroup, SearchWrapper } from "../../../share/filters";

export const ListViewContainer = styled.div`
  display: grid;
  padding: 24px 24px 16px;
  border-bottom: 1px solid var(--fourth-black-color);
  row-gap: 16px;

  @media (max-width: ${breakpoints.medium}px) {
    padding: 16px;
  }

  @media (max-width: ${breakpoints.small}px) {
    padding: 16px;
  }
`;

export const ListViewTopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ListViewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
  flex-wrap: wrap;
`;

export const ListViewSearchSection = styled.div`
  display: grid;
  gap: 16px;
`;

export const ListViewSearchWrapper = styled(SearchWrapper)`
  width: 100%;
  margin-bottom: 0;
  padding: 0;
`;

export const ListViewFilterGroup = styled(FilterGroup)`
  width: 100%;
  margin-bottom: 0;
  padding: 0;
  height: auto;
  flex-wrap: wrap;
  gap: 16px;
`;

export const MapToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid var(--third-black-color);
  border-radius: 4px;
  background: var(--primary-white-color);
  box-shadow: none;
  cursor: pointer;
  padding: 0;
  margin-right: -14px;

  &:disabled {
    background: var(--sixth-black-color);
    border-color: var(--sixth-black-color);
    cursor: not-allowed;
    pointer-events: none;

    img {
      opacity: 0.4;
    }
  }

  &:hover {
    background: var(--sixth-black-color);
  }

  img {
    width: 20px;
    height: 20px;
    display: block;
  }

  @media (max-width: ${breakpoints.medium}px) {
    margin-right: 0;
  }
`;

export const ListViewSearchRow = styled.div`
  display: grid;
  grid-template-columns: 48px repeat(
      2,
      minmax(0, calc((100% - 48px - 32px) / 2))
    );
  align-items: flex-start;
  gap: 16px;

  ${ListViewFilterGroup} {
    width: 100%;
  }

  @media (max-width: ${breakpoints.large}px) {
    grid-template-columns: 48px 1fr;
    grid-template-rows: auto auto;

    ${ListViewFilterGroup} {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr;

    ${MapToggleButton} {
      justify-self: flex-start;
    }
  }
`;
